import React, { useState } from 'react';
import type { FC } from 'react';

import Button from '@atlaskit/button/new';
import PremiumIcon from '@atlaskit/icon/core/premium';
import { PremiumTrialOnboardingModal } from '@confluence/premium-onboarding';
import { TriggerFrom } from '@confluence/premium-onboarding/entry-points/PremiumTrialOnboardingModal';

type HTV2ExplorePremiumCTAProps = {
	formattedTrialDaysLeft?: number;
	isDisabled?: boolean;
	onClick: () => void;
	children?: React.ReactNode;
};

export const HTV2ExplorePremiumCTA: FC<HTV2ExplorePremiumCTAProps> = ({
	children,
	formattedTrialDaysLeft,
	isDisabled,
	onClick,
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleClick = () => {
		setIsModalOpen((isModalOpen) => !isModalOpen);
	};

	const handleClose = () => {
		setIsModalOpen(false);
		onClick();
	};

	return (
		<>
			{isModalOpen && (
				<PremiumTrialOnboardingModal
					onClose={handleClose}
					triggerFrom={TriggerFrom.HOME_ONBOARDING_TAKEOVER_V2}
					daysLeft={formattedTrialDaysLeft}
				/>
			)}
			<Button
				iconBefore={PremiumIcon}
				isDisabled={isDisabled}
				onClick={handleClick}
				appearance="default"
			>
				{children}
			</Button>
		</>
	);
};
